package com.anjuros.website.templates.template5.styles

import com.anjuros.website.templates.template1.modules.Template1Theme
import com.anjuros.website.templates.template1.util.Template1Constants
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template5.modules.Template5Theme
import com.anjuros.website.templates.template5.modules.getColor
import com.anjuros.website.templates.template5.util.Template5Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexBasis
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val CompanyColorVar by StyleVariable<CSSColorValue>()

val Template5HeroFeatureCardStyle = CssStyle {

    base {
        Modifier
            .translateY(0.px)
            .transition(
                Transition.of(
                    TransitionProperty.All,
                    250.ms
                )
            )
    }

    hover {
        Modifier
            .translateY((-6).px)
    }

}

val Template5CallButton = CssStyle {

    base {
        Modifier
            .margin(topBottom = 15.px)
            .transition(Transition.of("all", 300.ms))
    }

    hover {
        Modifier
            .transform { translateY((-4).px) }

    }
    Breakpoint.MD { Modifier .margin(topBottom = 15.px) }
    Breakpoint.LG { Modifier .margin(topBottom = 0.px) }
    Breakpoint.XL { Modifier .margin(topBottom = 0.px)}
}

val Template5HeroH1FontStyle = CssStyle {
    base { Modifier.fontSize(42.px) }
    Breakpoint.MD { Modifier.fontSize(50.px) }
    Breakpoint.LG { Modifier.fontSize(64.px) }
    Breakpoint.XL { Modifier.fontSize(64.px)}
}

val Template5CategoryButtonStyle = CssStyle {

    base {
        Modifier
            .borderRadius(50.px)
            .transition(
                Transition.of(
                    TransitionProperty.All,
                    250.ms
                )
            )
            .boxShadow(
                offsetY = 8.px,
                blurRadius = 18.px,
                color = rgba(0, 0, 0, .06)
            )
    }

    hover {
        Modifier
            .translateY((-3).px)
    }

}

val Template5ProductImageStyle = CssStyle {

    base {
        Modifier
            .scale(1)
            .transition(
                Transition.of(
                    TransitionProperty.All,
                    350.ms
                )
            )
    }

    hover {
        Modifier
            .scale(1.06)
    }

}

val Template5ProductCardStyle = CssStyle {

    base {
        Modifier
            .translateY(0.px)
            .transition(
                Transition.of(
                    TransitionProperty.All,
                    250.ms
                )
            )
    }

    hover {
        Modifier
            .translateY((-10).px)
    }

}

val Template5CarouselArrowStyle = CssStyle {

    base {
        Modifier
            .backgroundColor(Colors.White)
            .borderRadius(50.percent)
            .border(
                1.px,
                LineStyle.Solid,
                rgba(220,220,220,.8)
            )
            .transition(
                Transition.of(
                    TransitionProperty.All,
                    250.ms
                )
            )
            .styleModifier {
                property(
                    "box-shadow",
                    """
                    0 10px 24px rgba(0,0,0,.08)
                    """.trimIndent()
                )
            }
    }

    hover {
        Modifier
            .backgroundColor(Template5Theme.Secondary.rgb)
            .translateY((-3).px)
            .styleModifier {
                property(
                    "box-shadow",
                    """
                    0 16px 32px rgba(0,0,0,.12)
                    """.trimIndent()
                )
            }
    }

}

val ProductCardMaxWidthStyle = CssStyle {

    base {
        Modifier.maxWidth(290.px)
    }

    Breakpoint.MD {
        Modifier.maxWidth(645.px)
    }

    Breakpoint.LG {
        Modifier.maxWidth(1080.px)
    }

    Breakpoint.XL {
        Modifier.maxWidth(1080.px)
    }
}

val ProductSingleCardWidthStyle = CssStyle {

    base {
        Modifier
            .width(250.px)
            .flexShrink(0)
    }

    Breakpoint.MD {
        Modifier
            .width(300.px)
            .flexShrink(0)
    }

    Breakpoint.LG {
        Modifier
            .width(320.px)
            .minHeight(470.px)
            .flexShrink(0)
    }

    Breakpoint.XL {
        Modifier
            .width(320.px)
            .minHeight(470.px)
            .flexShrink(0)
    }
}

val ProductRowPercStyle = CssStyle {

    base {
        Modifier.fillMaxWidth()
    }

    Breakpoint.MD {
        Modifier.fillMaxWidth(80.percent)
    }

    Breakpoint.LG {
        Modifier.fillMaxWidth(80.percent)
    }

    Breakpoint.XL {
        Modifier.fillMaxWidth(80.percent)
    }
}

val Template5HeroImageStyle = CssStyle {
    base { Modifier.height(400.px) }
    Breakpoint.MD { Modifier.height(400.px) }
    Breakpoint.LG { Modifier.flexBasis(46.percent)
        .height(620.px) }
    Breakpoint.XL { Modifier.flexBasis(46.percent)
        .height(620.px)}
}

val Template5FAQStyle = CssStyle {
    base { Modifier.width(90.percent) }
    Breakpoint.MD { Modifier.width(80.percent) }
    Breakpoint.LG { Modifier.width(600.px) }
    Breakpoint.XL { Modifier.width(600.px)}
}

val Template5FAQColumnStyle = CssStyle {
    base { Modifier.fillMaxWidth() }
    Breakpoint.MD { Modifier.fillMaxWidth(80.percent) }
    Breakpoint.LG { Modifier.maxWidth(900.px) }
    Breakpoint.XL { Modifier.maxWidth(900.px)}
}

val Template5ProductTitleStyle = CssStyle {
    base { Modifier .padding(topBottom = 60.px).fillMaxWidth(90.percent) }
    Breakpoint.MD { Modifier .padding(topBottom = 110.px).fillMaxWidth()}
    Breakpoint.LG { Modifier .padding(topBottom = 110.px).fillMaxWidth() }
    Breakpoint.XL { Modifier .padding(topBottom = 110.px).fillMaxWidth()}
}

val Template5ProductCategoryStyle = CssStyle {
    base { Modifier .fillMaxWidth().padding(leftRight = 10.px, bottom = 50.px,
        top = 20.px) }
    Breakpoint.MD { Modifier .fillMaxWidth(80.percent).padding(leftRight = 20.px, bottom = 50.px,
        top = 20.px)}
    Breakpoint.LG { Modifier .fillMaxWidth(60.percent).padding(leftRight = 20.px, bottom = 50.px,
        top = 20.px) }
    Breakpoint.XL { Modifier .fillMaxWidth(60.percent).padding(leftRight = 20.px, bottom = 50.px,
        top = 20.px)}
}

val Template5AboutImageStyle = CssStyle {
    base { Modifier .fillMaxWidth(80.percent).margin(bottom = 30.px) }
    Breakpoint.MD { Modifier .size(250.px).margin(bottom = 0.px)}
    Breakpoint.LG { Modifier .size(340.px).margin(bottom = 0.px) }
    Breakpoint.XL { Modifier .size(340.px).margin(bottom = 0.px)}
}

val Template5HeaderLinkStyle = CssStyle {

    cssRule(" > #highlight"){
        Modifier .width(0.px)
            .transition(Transition.of(property = "width", duration = 400.ms))
    }
    cssRule(":hover > #highlight"){
        Modifier  .width(50.px)

    }
}

val Template5ContactLinkStyle = CssStyle {

    cssRule(" > #contactValue"){
        Modifier .fontWeight(FontWeight.Normal)
            .transition(Transition.of(property = "fontWeight", duration = 400.ms))
    }
    cssRule(":hover > #contactValue"){
        Modifier  .fontWeight(FontWeight.Bold)

    }
}

val Template5ContactFooterLinkStyle = CssStyle {

    cssRule(" > #contactFooterValue"){
        Modifier .fontWeight(FontWeight.Normal)
            .transition(Transition.of(property = "fontWeight", duration = 400.ms))
    }
    cssRule(":hover > #contactFooterValue"){
        Modifier  .fontWeight(FontWeight.Bold)

    }
}

val Template5ContactSectionStyle = CssStyle {
    base { Modifier.padding(
        topBottom = 120.px,
        leftRight = 24.px
    ) }
    Breakpoint.MD { Modifier.padding(
        topBottom = 120.px,
        leftRight = 24.px
    )}
    Breakpoint.LG { Modifier.padding(
        topBottom = 120.px,
        leftRight = 40.px
    ) }
    Breakpoint.XL { Modifier.padding(
        topBottom = 120.px,
        leftRight = 40.px
    )}
}

val Template5ReviewSizeStyle = CssStyle {
    base { Modifier.fontSize(18.px).lineHeight(1.2) }
    Breakpoint.MD { Modifier.fontSize(20.px).lineHeight(1.2) }
    Breakpoint.LG { Modifier.fontSize(22.px).lineHeight(1.8) }
    Breakpoint.XL { Modifier.fontSize(22.px).lineHeight(1.8)}
}

val Template5ReviewPaddingStyle = CssStyle {
    base { Modifier.padding(24.px) }
    Breakpoint.MD { Modifier.padding(40.px) }
    Breakpoint.LG { Modifier.padding(48.px) }
    Breakpoint.XL { Modifier.padding(48.px)}
}

val Template5FooterSectionStyle = CssStyle {
    base { Modifier.padding(
        top = 20.px,
        bottom = 10.px,
        leftRight = 24.px
    ) }
    Breakpoint.MD { Modifier.padding(
        top = 20.px,
        bottom = 10.px,
        leftRight = 24.px
    )}
    Breakpoint.LG { Modifier.padding(
        top = 20.px,
        bottom = 10.px,
        leftRight = 40.px
    ) }
    Breakpoint.XL { Modifier.padding(
        top = 20.px,
        bottom = 10.px,
        leftRight = 40.px
    )}
}
